export default __webpack_public_path__ + "static/media/NovaOfertaBomba.c8897963.png";